import React, { useState, useEffect, forwardRef, useRef, useImperativeHandle } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

import CheckoutForm from "./CheckoutForm";
import { PAYMENTSERVER, PAYMENTSYSTEM, VENDORID } from "../../constants";
import { secureKeyGet } from "../../secretKey";
import { toast } from "react-toastify";

const StripePay = forwardRef(({ amount, setSelectedPaymentMethod,startPayment, props }, ref) => {
  const [clientSecret, setClientSecret] = useState("");
  const [stripePromise, setStripePromise] = useState(null);
  const formRef = useRef();

  useImperativeHandle(ref, () => ({
    async handleCardValidation() {
      return await formRef.current?.handleCardValidation();
    },
  }));

  useEffect(() => {
    if (!PAYMENTSYSTEM) return;

    // Stripe'i sadece aktifse yükle
    if(sessionStorage.getItem('stripeApiKey')) {
      var key = secureKeyGet(sessionStorage.getItem('stripeApiKey'));
      setStripePromise(loadStripe(key));
    }

    // PaymentIntent oluştur
    fetch(PAYMENTSERVER + "/create-payment-intent", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(
        {
        amount: amount,
        token: sessionStorage.getItem('token'),
        vendorId: VENDORID,

      }
      ),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.clientSecret) {
          setClientSecret(data.clientSecret);
        } else {
          toast.error("Cannot connect to Stripe: " + data.resMessage);
        }
      });
  }, []);

  const appearance = {
    theme: "stripe",
  };
  const options = {
    clientSecret,
    appearance,
  };

  return (
    <div className="App">
      {PAYMENTSYSTEM && clientSecret && stripePromise ? (
        <Elements options={options} stripe={stripePromise}>
          <CheckoutForm startPayment={startPayment} ref={formRef} setSelectedPaymentMethod={setSelectedPaymentMethod} props={props} />
        </Elements>
      ) : (
        <div className="flex flex-col items-center justify-center mt-10 h-64">
          <svg className="animate-spin h-6 w-6 text-gray-500 mb-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
          </svg>
          <p className="text-gray-600">Ödeme Yöntemleri Yükleniyor...</p>
        </div>

      )}
    </div>
  );

} );

export default  StripePay;
